module.exports = __webpack_public_path__ + "e4f19cb0146ad17b168eedf7f58059f2.png";